export const capitalizeWords = (sentence) => {
    return sentence.split(' ').map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
}

export const replaceSpecialCharacters = (text) => {
    text = text.replace(/[áâãàäÁÀÂÃÄ]/g, 'a');
    text = text.replace(/[éêèëÉÈÊË]/g, 'e');
    text = text.replace(/[íîìïÍÌÎÏ]/g, 'i');
    text = text.replace(/[óôõòöÓÒÔÕÖ]/g, 'o');
    text = text.replace(/[úûùüÚÙÛÜ]/g, 'u');
    text = text.replace(/[çÇ]/g, 'c');

    return text;
}